<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Onboarding" subtitle="Manage the landing pages to onboard new customers." :readonly="$authorised('mem/pricing/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no discounts found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />
				<app-table-column text="Name" />
				<app-table-column text="Default" align="center" />
				<app-table-column text="Plans" align="center" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label text="Online" type="success" v-if="item.status === 1" />
					<app-table-cell-label text="Offline" type="danger" v-if="item.status === 0" />
					<app-table-cell-text :text="item.name" />
					<app-table-cell-icon v-if="item.default" icon="tick" theme="green" align="center" />
					<app-table-cell-icon v-if="!item.default" icon="cross" theme="red" align="center" />
					<app-table-cell-text v-if="!item.plans.enabled" text="All" align="center" />
					<app-table-cell-text v-if="item.plans.enabled" :text="item.plans.available.length" align="center" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			filter: {
				status: [],
				type: []
			},
			layout: '64px auto 100px 100px',
			endpoint: 'membership/pricing/onboardings',
			live: 'membership/pricing/onboardings',
			edit: 'Membership.Pricing.Onboardings.Edit'
		}

	}

}

</script>

<style scoped>

</style>